/** @jsx jsx */
import { jsx, Styled } from 'theme-ui';
import Link from '../link';
import UnbulletedList from '../styles/unbulleted-list';
import { colors } from '../../gatsby-plugin-theme-ui';

export const Container = (props) => (
  <div
    sx={{
      display: ['none', null, 'block'],
      width: '19%',
      bg: 'PrimaryGray',
      flexBasis: '20%',
      fontSize: '1.8rem',
      lineHeight: 1.44,
    }}
    {...props}
  />
);

export const SiblingList = (props) => (
  <UnbulletedList
    sx={{
      position: 'sticky',
      top: 0,
      zIndex: 1,
    }}
    {...props}
  />
);

const linkStyles = {
  display: 'block',
  pl: '6.4rem',
  pr: '3.2rem',
  textDecoration: 'none',
  fontWeight: 'bold',
  color: 'PrimaryDarkBlue',
};

export const Sibling = (props) => (
  <Link
    sx={{
      ...linkStyles,
      bg: 'white',
      py: '2rem',
      boxShadow: 'inset 0 0px 3px -1px rgba(0,0,0,0.5)',
      '&.active': {
        color: 'SecondaryBlue2',
      },
    }}
    activeClassName="active"
    {...props}
  />
);

export const SectionList = (props) => (
  <UnbulletedList
    sx={{
      py: '1rem',
      boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.5)',
    }}
    {...props}
  />
);

export const Section = (props) => (
  <Link
    sx={{
      ...linkStyles,
      py: '0.5rem',
      '&:hover': {
        // boxShadow: `inset 0 1px 3px 0 ${colors.SecondaryGray3}`,
         color: 'SecondaryBlue2',
        //backgroundColor: 'SecondaryGray4',
        //boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.5)',
      },
    }}
    {...props}
  />
);
